import { useState } from 'react';
import { Link } from 'react-router-dom';

import { faCheck, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SellerItem({ row, onSelect, isSelected }) {
    const [isEditing, setIsEditing] = useState(false);
    const [numVendas, setNumVendas] = useState(row.original.num_vendas);
    const seller = row.original;

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleCheckboxChange = () => onSelect(seller.id);
    const { key, ...rowProps } = row.getRowProps();

    const handleDoubleClick = () => {
        setIsEditing(true);
    };

    const handleChange = (e) => {
        setNumVendas(e.target.value);
    };

    const handleSave = async () => {
        const response = await fetch(`${baseUrl}/manager/representantes/vendas/atualizar/${seller.id}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ num_vendas: numVendas }),
        });

        if (response.ok) {
            setIsEditing(false);
        }
    };

    return (
        <tr {...rowProps} className="bseller-b bseller-stroke">
            <td className="text-left xl:p-4 text-sm font-medium">
                <input type="checkbox" checked={isSelected} onChange={handleCheckboxChange} />
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium uppercase">{seller.nome}</td>
            <td className="p-2 2xl:p-4 text-sm text-black font-medium leading-tight max-w-80" onDoubleClick={handleDoubleClick}>
                {isEditing ? (
                    <div className="relative w-fit flex items-center gap-2">
                        <input type="number" value={numVendas} onChange={handleChange} className="border px-2 py-2 rounded w-20" />
                        <button onClick={handleSave} className="absolute inset-1 left-auto bg-green-500 text-white px-1.5 rounded">
                            <FontAwesomeIcon icon={faCheck} />
                        </button>
                    </div>
                ) : (
                    <span>{numVendas}</span>
                )}
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left text-xs 2xl:text-sm font-medium">
                {seller.ativo ? (
                    <span className="w-10 bg-green-500 text-white px-3.5 py-1">Sim</span>
                ) : (
                    <span className="w-10 bg-neutral-400 text-white px-3 py-1">Não</span>
                )}
            </td>
            <td className="p-2 pr-0 text-left 1xl:p-4 xl:pr-0 text-xs 1xl:text-sm">
                <div className="flex items-center gap-2">
                    <Link
                        to={`/manager/representantes/editar/${seller.id}`}
                        className="bg-primary w-8 h-8 rounded-full flex items-center justify-center duration-200 ease-in-out hover:bg-opacity-80"
                    >
                        <FontAwesomeIcon icon={faEdit} className="text-white ml-[1px] mb-[1px]" />
                    </Link>
                </div>
            </td>
        </tr>
    );
}

export default SellerItem;
